import { SVGProps } from 'react'
import * as ResponsiveIcons from './responsive-icons'
export * from './icons'
export { ResponsiveIcons }
export type IconProps = SVGProps<SVGSVGElement>
